import React from 'react';
import styled from 'styled-components';
import AttendeePdfAccessLayout from './AttendeePdfAccessLayout';
import { mediaQueries } from '@general/breakpoints';

const ContainerStyled = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;

    @media ${mediaQueries.md} {
        width: 80%;
        max-width: 800px;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #666;
`;

const AttendeePdfAccessModal = ({ onClose, eventLink }) => {
    const closeModal = () => {
        onClose();
    };

    const closeModalAndRedirect = () => {
        onClose();
        window.location.href = eventLink; // Redirect to the eventLink URL
    };

    return (
        <ContainerStyled>
            <CloseButton onClick={closeModal}>Close  X</CloseButton>
            <AttendeePdfAccessLayout onAccept={closeModalAndRedirect} eventLink={eventLink} />
        </ContainerStyled>
    );
};

export default AttendeePdfAccessModal;